module.exports = __webpack_public_path__ + "img/3.748782db.jpg";